import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-3 my-3 px-4" }
const _hoisted_2 = { class: "flex align-items-center gap-3 flex-1" }
const _hoisted_3 = { class: "ml-auto inline-flex gap-3" }
const _hoisted_4 = { class: "flex align-items-center gap-3 w-full accordian__header" }
const _hoisted_5 = { class: "row__count__container flex align-items-center justify-content-center" }
const _hoisted_6 = { class: "flex align-items-center gap-3 w-full accordian__header" }
const _hoisted_7 = { class: "row__count__container flex align-items-center justify-content-center" }
const _hoisted_8 = { class: "flex align-items-center gap-3 w-full accordian__header" }
const _hoisted_9 = { class: "row__count__container flex align-items-center justify-content-center" }
const _hoisted_10 = { class: "flex align-items-center gap-3 w-full accordian__header" }
const _hoisted_11 = { class: "row__count__container flex align-items-center justify-content-center" }
const _hoisted_12 = {
  key: 2,
  class: "p-8 w-full text-center text-3xl text-700",
  textContent: 'Preparing Interface'
}

import { ref, onMounted, onBeforeUnmount, onBeforeMount } from 'vue';
import Menu from 'primevue/menu';
import download from 'downloadjs';
import Papa from 'papaparse';
import CancelWorkflowDialog from './CancelWorkflowDialog.vue';
import MTSSReferralTable from './MTSSReferralTable.vue';
import InitialEvalReferralTable from './InitialEvalReferralTable.vue';
import TransferReferralTable from './TransferReferralTable.vue';
import ReassignmentReferralTable from './ReassignmentReferralTable.vue';
import ProcessReferralDialog from './ProcessReferralDialog.vue';
import UserReferralSISModal from './UserReferralSISModal.vue';
import Dialog from 'primevue/dialog';
import Accordian from 'primevue/accordion';
import AccordianTab from 'primevue/accordiontab';
import { EMIT, PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { DisciplineStateInterface } from '@/types';
import { StudentService } from '@/services';
import {
  useStudentReferralStore,
  useOrganizationStore,
  useClinicianOrganizationStore,
  useServicesStore,
  useDisciplineStore,
  useBuildingStore,
} from '@/store';
import { can, usePersonTypes, useRequestCancel, useFlattenOrganizations, useTenant } from '@/composables';
import { TreeNode } from 'primevue/tree';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserReferralWorkflowModal',
  setup(__props, { emit: __emit }) {

const $tenant = useTenant();

const emit = __emit;

const modalVisible = ref(true);
const shouldProcessReferrals = ref<boolean>(false);
const organizationFilter = ref<number>();
const selectedOrganization = ref();
const openProcess = ref<boolean>(false);
const openCancel = ref<boolean>(false);
const openSISModal = ref<boolean>(false);
const organizations = ref<TreeNode[]>([]);
const bulkFile = ref();

const importMenu = ref();
const importMenuItems = ref<Array<{ label: string; icon: string; command: () => void }>>([]);

const referralStore = useStudentReferralStore();
const servicesStore = useServicesStore();
const organizationStore = useOrganizationStore();
const clinicianOrganizationStore = useClinicianOrganizationStore();
const disciplineStore = useDisciplineStore();
const requestCancel = useRequestCancel();

const buildingStore = useBuildingStore();
const disciplines = ref<DisciplineStateInterface[]>([]);

const openProcessModal = () => (openProcess.value = true);
const closeProcessModal = () => (openProcess.value = false);
const openCancelModal = () => (openCancel.value = true);
const closeCancelModal = () => (openCancel.value = false);

const cancel = () => {
  emit(EMIT.CANCEL);
  modalVisible.value = false;
  return;
};

const onCancel = () => {
  closeCancelModal();
  cancel();
};

const onImportMenu = (event) => importMenu.value.toggle(event);

const onSISModalCancel = () => (openSISModal.value = false);

onBeforeMount(async () => {
  window.addEventListener('beforeunload', onLeaving);
  await referralStore.loadOptions();
});

onMounted(() => {
  if (can([PERMISSIONS.REFERRAL_PROCESS])) init();
});

onBeforeUnmount(() => {
  toggleGesture(false);
  requestCancel.requestSaverAbortAll();
  window.removeEventListener('beforeunload', onLeaving);
});

//turn off/ on the gestures for mac
const toggleGesture = (stopGesture: boolean) => {
  document.body.style = stopGesture ? 'overscroll-behavior-x: none !important' : 'auto';
};

const init = async () => {
  toggleGesture(true);
  buildingStore.organizationBuildings = [];
  await disciplineStore.getDisciplines();
  await organizationStore.getOrganizations();
  organizations.value = useFlattenOrganizations(organizationStore.organizations.data);
  disciplines.value = disciplineStore.disciplines;
  if (usePersonTypes.isSchoolAdmin()) {
    organizationFilter.value = organizations.value.length === 1 ? organizations.value[0].id : undefined;

    if (organizations.value.length === 1) {
      await onOrganizationSelect();
    }
  }
};

const onLeaving = (event) => event.preventDefault();

const doDownload = async () => {
  const response = await StudentService.getStudentReferralTemplate();
  const content = response.headers['content-type'];

  download(response.data, 'student-referral-template.csv', content);
};

const saveAllProcessing = () => {
  closeProcessModal();
  shouldProcessReferrals.value = true;
};

const onOrganizationSelect = async () => {
  const organization = organizations.value.find((item) => item.id === organizationFilter.value);
  selectedOrganization.value = organization;
  defineImportMenuItems(organization);
  referralStore.resetReferralData();
  await clinicianOrganizationStore.getCliniciansForOrganizationRequest(organizationFilter.value as number);
  await servicesStore.getServices(organizationFilter.value as number);
  await disciplineStore.getFilterDisciplines(organizationFilter.value as number);
  await buildingStore.fetchOrganizationBuildings(organizationFilter.value as number);
  buildingStore.organizationBuildings.sort((a, b) => a.name.localeCompare(b.name));
};

const defineImportMenuItems = (organization) => {
  importMenuItems.value = [];
  importMenuItems.value.push({
    label: 'CSV File',
    icon: 'm-icon insert_drive_file',
    command: () => bulkFile.value.click(),
  });

  if (
    $tenant.tenantSettingEnabled(TENANT_SETTINGS.USE_INTEGRATION_SIS_SCHOOLDAY_ONEROSTER) &&
    organization.integration_organization
  ) {
    importMenuItems.value.push({
      label: 'School Day (SIS)',
      icon: 'm-icon storage',
      command: () => (openSISModal.value = true),
    });
  }
};

const tableSaved = () => (shouldProcessReferrals.value = false);

const onBulkFileUpload = () => {
  Papa.parse(bulkFile.value.files[0], {
    header: true,
    complete: function (results) {
      results.data.forEach((row) => {
        if (row.building) {
          const normalizedCSVBuildingName = row.building.trim().toLowerCase();
          const foundBuilding = buildingStore.organizationBuildings.find(
            (b) => b.name.trim().toLowerCase() === normalizedCSVBuildingName,
          );
          if (foundBuilding) {
            row.building_id = foundBuilding.id;
            row.building_name = foundBuilding.name;
          }
        }

        if (row.referred_discipline) {
          const normalizedCSVDisciplineName = row.referred_discipline.trim().toLowerCase();
          const foundDiscipline = disciplines.value.find(
            (b) => b.name.trim().toLowerCase() === normalizedCSVDisciplineName,
          );
          if (foundDiscipline) {
            row.discipline_id = foundDiscipline.id;
            row.discipline_name = foundDiscipline.name;
          }
        }
      });
      referralStore.onBulkFileImport(results.data);
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    class: "workflow__dialog__container bg-white border-noround p-dialog-maximized",
    modal: true,
    closable: false,
    "close-on-escape": false,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h2", {
        class: "px-3",
        textContent: 'Referral Management Workflow'
      }, null, -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(ProcessReferralDialog, {
        open: openProcess.value,
        onCancel: closeProcessModal,
        onUpdate: saveAllProcessing
      }, null, 8, ["open"]),
      _createVNode(CancelWorkflowDialog, {
        open: openCancel.value,
        onCancel: closeCancelModal,
        onUpdate: onCancel
      }, null, 8, ["open"]),
      (selectedOrganization.value?.integration_organization)
        ? (_openBlock(), _createBlock(UserReferralSISModal, {
            key: 0,
            organization: selectedOrganization.value,
            open: openSISModal.value,
            onCancel: onSISModalCancel
          }, null, 8, ["organization", "open"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!organizations.value.length)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                height: "36px",
                width: "160px",
                "border-radius": "4"
              }))
            : (_openBlock(), _createBlock(_component_Dropdown, {
                key: 1,
                id: "organizations",
                modelValue: organizationFilter.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organizationFilter).value = $event)),
                type: "secondary",
                options: organizations.value,
                filter: "",
                "option-label": "name",
                "option-value": "id",
                placeholder: "Select Organization",
                onChange: onOrganizationSelect
              }, null, 8, ["modelValue", "options"])),
          _createVNode(_component_AppButton, {
            "icon-left": "swap_vert",
            type: "secondary",
            text: "Import",
            "aria-haspopup": "true",
            "aria-controls": "overlay_menu",
            disabled: !organizationFilter.value,
            onClick: onImportMenu
          }, null, 8, ["disabled"]),
          _createVNode(_unref(Menu), {
            id: "overlay_menu",
            ref_key: "importMenu",
            ref: importMenu,
            model: importMenuItems.value,
            popup: true
          }, null, 8, ["model"]),
          _createElementVNode("input", {
            ref_key: "bulkFile",
            ref: bulkFile,
            type: "file",
            class: "hidden",
            onChange: onBulkFileUpload
          }, null, 544),
          _createElementVNode("div", {
            class: "flex text-primary cursor-pointer",
            onClick: _withModifiers(doDownload, ["stop","prevent"])
          }, [
            _createVNode(_component_Icon, { name: "insert_drive_file" }),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "underline mt-1 ml-2 text-sm" }, "Download Template", -1))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppButton, {
              id: "cancel_service_btn",
              type: "secondary",
              text: "Cancel / Close",
              onClick: openCancelModal
            }),
            _createVNode(_component_AppButton, {
              id: "save_service_btn",
              type: "primary",
              text: "Process Referrals",
              disabled: !organizationFilter.value,
              onClick: openProcessModal
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      (!_unref(referralStore).referralOptionsloading)
        ? (_openBlock(), _createBlock(_unref(Accordian), {
            key: 1,
            multiple: true,
            "active-index": [0, 1, 2, 3]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AccordianTab), null, {
                header: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-bold white-space-nowrap header__text" }, "MTSS Referral", -1)),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(referralStore).mTSSReferralTableData.length), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(MTSSReferralTable, {
                    save: shouldProcessReferrals.value,
                    "organization-id": organizationFilter.value,
                    buildings: _unref(buildingStore).organizationBuildings,
                    onSave: tableSaved
                  }, null, 8, ["save", "organization-id", "buildings"])
                ]),
                _: 1
              }),
              _createVNode(_unref(AccordianTab), null, {
                header: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-bold white-space-nowrap header__text" }, "Initial Evaluation/Referral", -1)),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(referralStore).initialEvalReferralTableData.length), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(InitialEvalReferralTable, {
                    save: shouldProcessReferrals.value,
                    "organization-id": organizationFilter.value,
                    buildings: _unref(buildingStore).organizationBuildings,
                    disciplines: disciplines.value,
                    services: _unref(disciplineStore).disciplines,
                    onSave: tableSaved
                  }, null, 8, ["save", "organization-id", "buildings", "disciplines", "services"])
                ]),
                _: 1
              }),
              _createVNode(_unref(AccordianTab), null, {
                header: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-bold white-space-nowrap header__text" }, "Transfer", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(referralStore).transferReferralTableData.length), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(TransferReferralTable, {
                    save: shouldProcessReferrals.value,
                    "organization-id": organizationFilter.value,
                    buildings: _unref(buildingStore).organizationBuildings,
                    disciplines: disciplines.value,
                    services: _unref(disciplineStore).disciplines,
                    onSave: tableSaved
                  }, null, 8, ["save", "organization-id", "buildings", "disciplines", "services"])
                ]),
                _: 1
              }),
              _createVNode(_unref(AccordianTab), null, {
                header: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-bold white-space-nowrap header__text" }, "Reassignment", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(referralStore).reassignmentReferralTableData.length), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(ReassignmentReferralTable, {
                    save: shouldProcessReferrals.value,
                    "organization-id": organizationFilter.value,
                    buildings: _unref(buildingStore).organizationBuildings,
                    disciplines: disciplines.value,
                    services: _unref(disciplineStore).disciplines,
                    onSave: tableSaved
                  }, null, 8, ["save", "organization-id", "buildings", "disciplines", "services"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("h2", _hoisted_12))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})